"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const helpers_1 = require("../../commonFiles/helpers");
const react_router_dom_1 = require("react-router-dom");
const URLs_1 = require("../utility/URLs");
function ArticlesTable(props) {
    const articles = props.articles;
    const deleteArticle = props.deleteArticle;
    function hasCategories(Obj, Or = null) {
        var _a;
        if (articles && ((_a = articles[0]) === null || _a === void 0 ? void 0 : _a.categories))
            return Obj;
        else
            return Or;
    }
    function hasIsTransated(Obj, Or = null) {
        var _a;
        if (articles && ((_a = articles[0]) === null || _a === void 0 ? void 0 : _a.isTranslated) != undefined)
            return Obj;
        else
            return Or;
    }
    return (react_1.default.createElement(react_bootstrap_1.Table, { striped: true, bordered: true, hover: true },
        react_1.default.createElement("thead", null,
            react_1.default.createElement("tr", null,
                react_1.default.createElement("th", null, "#"),
                react_1.default.createElement("th", null, "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0645\u0642\u0627\u0644\u0629"),
                react_1.default.createElement("th", null, "\u0627\u0644\u062A\u0635\u0646\u064A\u0641\u0627\u062A"),
                react_1.default.createElement("th", null, "\u0645\u0641\u0639\u0644\u0629\u061F"),
                react_1.default.createElement("th", null, "\u0627\u0644\u0648\u0635\u0641"),
                react_1.default.createElement("th", null, "thumbnail"),
                hasIsTransated(react_1.default.createElement("th", null, "\u0645\u062A\u0631\u062C\u0645")),
                deleteArticle ? react_1.default.createElement("th", null) : null)),
        react_1.default.createElement("tbody", null, articles === null || articles === void 0 ? void 0 : articles.map((article, index) => {
            var _a;
            return (react_1.default.createElement("tr", { key: index },
                react_1.default.createElement("td", null,
                    " ",
                    react_1.default.createElement(react_router_dom_1.Link, { to: URLs_1.Routes.articleShow(article.id) },
                        " ",
                        article.id,
                        "  "),
                    " "),
                react_1.default.createElement("td", null, article.title),
                react_1.default.createElement("td", null, (_a = article === null || article === void 0 ? void 0 : article.categories) === null || _a === void 0 ? void 0 : _a.map((category, index) => react_1.default.createElement(react_router_dom_1.Link, { key: index, to: URLs_1.Routes.categoryShow(category.id) }, (category === null || category === void 0 ? void 0 : category.name) + ' '))),
                react_1.default.createElement("td", null, article.activated ? 'مفعل' : 'غير مفعل'),
                react_1.default.createElement("td", null, (0, helpers_1.truncate)(article.description)),
                react_1.default.createElement("td", null,
                    react_1.default.createElement("img", { src: article.hasThumbnail ? URLs_1.Api.articleThumbnail(article === null || article === void 0 ? void 0 : article.id) : null, className: 'maxWidth100' })),
                hasIsTransated(react_1.default.createElement("td", null, article.isTranslated ? 'نعم' : 'لا')),
                deleteArticle ? react_1.default.createElement("td", { onClick: () => deleteArticle(article.id) }, "\u062D\u062F\u0641") : null));
        }))));
}
exports.default = ArticlesTable;
